import React, { useEffect, useState } from "react";
import { LinkContainer } from "react-router-bootstrap";
import { Button } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import axios from "axios";
import { environment } from "../../../environment";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import Swal from "sweetalert2";
import { type } from "os";
import NavbarNew from "../../Components/NavbarNew";

const { SearchBar } = Search;

const ITExecutiveDashboard = (history) => {
  return (
    <>
      <div class="container-fluid">
        <NavbarNew />
        <div>Hello</div>
      </div>
    </>
  );
};

export default ITExecutiveDashboard;
